"use client";

import { Button, Icon } from "@cloai/uikit";
import { Switch } from "@legendapp/state/react";
import { memo, ReactNode } from "react";

import { useProfileContext, useThemeContext } from "@/providers";

import { FEATURE_FLAGS } from ".constants/featureFlags";

type ThemeTogglerVariant = "header" | "burger";

export const ThemeToggler = memo(
  ({ variant }: { variant: ThemeTogglerVariant }) => {
    const profile = useProfileContext();
    const { theme, toggleTheme } = useThemeContext();

    if (!FEATURE_FLAGS.IS_LIGHT_THEME_ENABLED || !profile) {
      return null;
    }

    const variantComponent: Record<ThemeTogglerVariant, ReactNode> = {
      header: (
        <Button
          isIconOnly
          size="sm"
          radius="full"
          onClick={toggleTheme}
          className="!hide md:!flex"
        >
          <Switch value={theme}>
            {{
              system: () => <Icon icon="light_mode" />,
              dark: () => <Icon icon="light_mode" />,
              light: () => <Icon icon="dark_mode" />,
            }}
          </Switch>
        </Button>
      ),
      burger: (
        <Button
          startContent={
            <Switch value={theme}>
              {{
                system: () => <Icon icon="light_mode" />,
                dark: () => <Icon icon="light_mode" />,
                light: () => <Icon icon="dark_mode" />,
              }}
            </Switch>
          }
          variant="ghost"
          wide
          centerText
          onClick={toggleTheme}
        >
          <Switch value={theme}>
            {{
              system: () => "Toggle theme",
              dark: () => "Light theme",
              light: () => "Dark theme",
            }}
          </Switch>
        </Button>
      ),
    };

    return variantComponent[variant];
  },
);
ThemeToggler.displayName = "ThemeToggler";
